import { FaPenToSquare, FaEye } from "react-icons/fa6";

const InfoSummeryEvent = ({ event }) => {
  return (
    <div className="grid sm:grid-cols-7 grid-cols-4 items-center py-3 px-4">
      <p className="col-span-2 sm:col-span-3 font-medium truncate">
        {event.name}
      </p>
      <p className="col-span-1 text-center text-sm text-base-content/70">
        {event.date && new Date(event.date).toLocaleDateString("sv-SE")}
      </p>
      <p className="hidden sm:block col-span-1 text-center text-sm text-base-content/70 truncate">
        {event.posted_by_name}
      </p>
      <div className="col-span-1 flex justify-center">
        <a href={`userprofile/editevent?slug=${event.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaPenToSquare size={15} />
          </button>
        </a>
      </div>
      <div className="col-span-1 flex justify-center">
        <a href={`/events/${event.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaEye size={15} />
          </button>
        </a>
      </div>
    </div>
  );
};

export default InfoSummeryEvent;
